'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { writeLastVisitedPath } from '@/lib/landing';

// Mounted once in the (app) layout. Writes the current pathname (+
// search) to localStorage on every route change so the "Last visited"
// landing preference has a path to redirect to.
//
// The schedule root (`/`) is skipped — landing-redirect on `/` with
// `last` preference would loop back to `/` and gain nothing.
export function LastVisitedTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    if (pathname === '/') return;
    const qs = searchParams?.toString();
    const path = qs ? `${pathname}?${qs}` : pathname;
    writeLastVisitedPath(path);
  }, [pathname, searchParams]);

  return null;
}
